export default __webpack_public_path__ + "static/mockup-widget-43fa5e65e8459ba78cbdd1288c87a49a.webp";